import React from 'react';

interface GameInstructionsProps {
  onStartGame: () => void;
}

export const GameInstructions: React.FC<GameInstructionsProps> = ({ onStartGame }) => {
  return (
    <div className="instructions-modal">
      <div className="instructions-content">
        <h2 className="text-3xl font-bold text-center mb-6 text-blue-600">
          📈 Ticker Tape Rush - How to Play
        </h2>
        
        <div className="instruction-steps">
          <div className="step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h3 className="font-semibold text-lg mb-2">Watch the Tickers</h3>
              <p>Stock names will scroll across the screen with arrows</p>
              <div className="example-ticker">
                <span className="stock-example">AAPL</span>
                <span className="arrow-up">⬆️</span>
                <span className="stock-example">TSLA</span>
                <span className="arrow-down">⬇️</span>
              </div>
            </div>
          </div>

          <div className="step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h3 className="font-semibold text-lg mb-2">Remember the ARROWS Only!</h3>
              <p className="text-red-600 font-medium">⚠️ Don't worry about stock names - just focus on the arrow directions!</p>
              <div className="focus-example">
                <div className="focus-item">
                  <span className="dim-text">AAPL</span>
                  <span className="highlight-arrow">⬆️ UP</span>
                </div>
                <div className="focus-item">
                  <span className="dim-text">TSLA</span>
                  <span className="highlight-arrow">⬇️ DOWN</span>
                </div>
              </div>
            </div>
          </div>

          <div className="step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h3 className="font-semibold text-lg mb-2">Answer the Questions</h3>
              <p>For each stock name, remember which arrow it had:</p>
              <div className="question-example">
                <div className="question-item">
                  <span className="question-stock">AAPL</span>
                  <span className="question-text">had which arrow?</span>
                  <div className="answer-buttons-example">
                    <button className="answer-btn up">⬆️ UP</button>
                    <button className="answer-btn down">⬇️ DOWN</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="key-tips">
          <h3 className="font-semibold text-lg mb-3 text-orange-600">🎯 Key Tips:</h3>
          <ul className="tips-list">
            <li>✅ Focus ONLY on the arrow directions (⬆️ or ⬇️)</li>
            <li>✅ You have 8 seconds to watch</li>
            <li>✅ The game gets harder as you improve</li>
            <li>❌ Don't try to memorize stock names - they're shown in the questions</li>
          </ul>
        </div>

        <div className="start-section">
          <p className="text-center text-gray-600 mb-4">
            Ready to test your memory? Let's start with 4 stocks!
          </p>
          <button 
            className="start-game-btn"
            onClick={onStartGame}
          >
            🚀 Start Playing
          </button>
        </div>
      </div>
    </div>
  );
};